import { MjmlColumn, MjmlSection, MjmlText } from "@faire/mjml-react";
import { populateVariables } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { Section, SharedProps } from "@redotech/redo-model/email-builder";
import htmlReactParser from "html-react-parser";
import { memo } from "react";

export type TextState = Section.Text & SharedProps;

export const processQuillHtml = (html: string, linkColor: string) => {
  return html
    .replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;")
    .replaceAll("<a href", `<a style="color: ${linkColor}" href`)
    .replaceAll("<p></p>", "<br>")
    .replaceAll(`<p class="ql-align-center"></p>`, "<br>");
};

export const EmailText = memo(function EmailText(props: TextState) {
  const quillHtml = processQuillHtml(props.text, props.linkColor);
  // the email builder doesn't use this component to render,
  // but just in case
  const text = props.isBuilder
    ? quillHtml
    : populateVariables(quillHtml, props.schemaInstance);

  const padding = props.sectionPadding;

  return (
    <MjmlSection
      backgroundColor={props.sectionColor}
      paddingBottom={padding.bottom}
      paddingLeft={padding.left}
      paddingRight={padding.right}
      paddingTop={padding.top}
    >
      <MjmlColumn>
        <MjmlText
          color={props.textColor}
          fontFamily={props.fontFamily}
          fontSize={props.fontSize}
        >
          {htmlReactParser(text)}
        </MjmlText>
      </MjmlColumn>
    </MjmlSection>
  );
});

export const NestedEmailText = memo(function NestedEmailText(props: TextState) {
  const text = props.isBuilder
    ? props.text
    : populateVariables(props.text, props.schemaInstance);

  const padding = props.sectionPadding;

  return (
    <MjmlText
      color={props.textColor}
      containerBackgroundColor={props.sectionColor}
      fontFamily={props.fontFamily}
      fontSize={props.fontSize}
      paddingBottom={padding.bottom}
      paddingLeft={padding.left}
      paddingRight={padding.right}
      paddingTop={padding.top}
    >
      {htmlReactParser(text)}
    </MjmlText>
  );
});
